import React, { useEffect, useRef, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { bindSaleNoRequest } from "../../../store/actions";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import generatePDF from "react-to-pdf";
import {
  AuctioneerListDetails,
  fetchReportDataTcsDetails,
  fetchReportDataTdsDetails,
  getWarehouseUserInvoice,
  categoryWiseSoldQty,
  buyerPaymentStatusReport,
  getSaleProgramDetails,
} from "./api";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import CustomToast from "../../../components/Toast";

function MyReportsTest({ modalTitle, reportType }) {
  const pdfContainerRef = useRef();
  const seasonYear = moment().year();
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 6; i++) {
    const year = currentYear - i;
    years.push(year);
  }

  const { auctionDetailId, auctionCenterId, userId } = useAuctionDetail();

  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);
  const [auctioneerList, setAuctioneerList] = useState();
  const [categoryListData, setCategoryListData] = useState();
  const [headerMapping, setHeaderMapping] = useState();
  const [warehouseUserInvoice, setWarehouseUserInvoice] = useState(null);
  const [auctionVarient, setAuctionVarient] = useState(null);
  const [paymentHeaderMapping, setPaymentHeaderMapping] = useState();
  const [programDetails, setProgramDetails] = useState([]);

  const [allSaleNoList, setallSaleNoList] = useState([]);
  const dispatch = useDispatch();
  const saleNoData = useSelector((state) => state.saleNoReducer.saleList);

  const [viewOption, setViewOption] = useState({
    saleNoWise: 0,
    paymentDateRange: 1,
  });

  let userID = atob(localStorage.getItem("argument2"));

  const [formData, setFormData] = useState({
    season: "",
    saleNo: "",
    entity: userID,
    report: "1",
    paymentStartDate: new Date(),
    paymentEndDate: new Date(),
    reportFor: reportType,
    auctioneerId: "",
    month: "",
    status: 0,
    buyer_prompt_date: "",
    auction_date: "",
  });

  const [buyerPaymentData, setBuyerPaymentData] = useState();

  const {
    season,
    saleNo,
    entity,
    report,
    paymentStartDate,
    paymentEndDate,
    reportFor,
    month,
    auctioneerId,
    status,
    auction_date,
    buyer_prompt_date,
  } = formData;

  useEffect(() => {
    const pathname = window.location.pathname;
    const auctionVariantEncoded = pathname?.split("/")[5];
    let auctionVariantVal = auctionVariantEncoded
      ? atob(auctionVariantEncoded)
      : null;
    setAuctionVarient(auctionVariantVal);
  }, []);

  const PrintPreview = () => {
    window.print();
  };

  const handleExcelExport = () => {
    const table = document.getElementById("table-content");
    const wb = XLSX.utils.table_to_book(table);
    XLSX.writeFile(wb, "TCS Details" + ".xlsx");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRadioChange = (type) => {
    if (type === "saleNoWise") {
      setViewOption({ saleNoWise: 1, paymentDateRange: 0 });
      setFormData({
        season: "",
        saleNo: "",
        entity: userID,
        report: report,
        paymentStartDate: new Date(),
        paymentEndDate: new Date(),
        reportFor: reportType,
        status: status,
        auction_date: auction_date,
        buyer_prompt_date: auction_date,
      });

      setData(null);
      setCategoryListData(null);
      setWarehouseUserInvoice(null);
      setLoader(false);
    } else if (type === "paymentDateRange") {
      setViewOption({ saleNoWise: 0, paymentDateRange: 1 });
      setFormData({
        season: "",
        saleNo: "",
        entity: userID,
        report: report,
        paymentStartDate: new Date(),
        paymentEndDate: new Date(),
        reportFor: reportType,
        status: status,
        auction_date: auction_date,
        buyer_prompt_date: auction_date,
      });

      setData(null);
      setCategoryListData(null);
      setWarehouseUserInvoice(null);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (season !== "") {
      dispatch(
        bindSaleNoRequest({
          season: season,
          auctionCenterId: auctionCenterId,
        })
      );
    }
  }, [season]);

  useEffect(() => {
    setallSaleNoList(saleNoData);
  }, [saleNoData]);

  useEffect(() => {
    const temp = {
      season: season,
      saleNo: parseInt(saleNo),
      auctionCenterId: parseInt(auctionCenterId),
    };

    const fetchData = async () => {
      setLoader(true);
      try {
        const data = await AuctioneerListDetails(temp);
        setAuctioneerList(data.responseData);
      } catch (error) {
        console.error("Error fetching report data:", error);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };
    if (reportType == "5" && temp.saleNo) {
      fetchData();
    }
  }, [saleNo]);

  const { saleNoWise, paymentDateRange } = viewOption;

  useEffect(() => {
    const headerMapping = {
      season: "Season",
      saleNo: "Sale No",
      saleDate: "Sale Date",
      aucSellerEligibility: "Auct Eligibility",
      invoiceNo: "Invoice No",
      ackNo: "Ack No",
      irnNo: "IRN No",
      ackDate: "Ack Date",
      invoiceDate: "Invoice Date",
      invoiceIssuer: "Invoice Issuer",
      gstnOfSellerAuctioneerTeaBoard: "GSTN of Seller/Auctioneer/Tea Board",
      value: "Value",
      goodsService: "Goods/Service",
      hsnSac: "HSN/SACC",
      taxableValue: "Taxable Value",
      igstRate: "IGST Rate",
      igstValue: "IGST Value",
      cgstRate: "CGST Rate",
      cgstValue: "CGST Value",
      sgstRate: "SGST Rate",
      sgstValue: "SGST Value",
      invoiceAmount: "Invoice Amount",
      invoiceRaisedOnEntityName: "Invoice Raised on entity name (Auctioneer)",
      gstnOfEntityOnWhomInvoiceIsRaised:
        "GSTN of the entity on whom the invoice is raised (Buyer)",
      placeOfSupply: "Place of Supply",
      tcsIgstValue: "TCS IGST Value",
      tcsCgstValue: "TCS CGST Value",
      tcsSgstValue: "TCS SGST Value",
      tcsGstNo: "TCS GST No",
      payOutPushDate: "Pay Out Push Date",
      bankDate: "Bank Date",

      //   "auctEligibility",
      //   "lotNo",
      //   "dealId",
      //  "goodsOrService",
      //   "hsnSacc",
      //   "tdsValue",
      //   "paymentDateRange",
      //   "paymentStartDate",
      //   "paymentEndDate",
      //   "entity",
      //   "report",
      //   "saleNoWise",
      //   "issuerGSTIN",
      //   "auctionCenterId",
      //   "auctionVarient"
    };
    setHeaderMapping(headerMapping);
  }, [season, saleNo]);

  // useEffect(async () => {
  //   const paymentHeaderMapping = {
  //     season: "Season",
  //     saleNo: "Sale No",
  //     buyerCode: "Buyer Code",
  //     buyerName: "Buyer Name",
  //     saleDate: "Sale Date",
  //     buyerPromptDate: "Buyer’s Prompt Date",
  //     markCode: "Mark Code",
  //     bankTransactionDate: "Bank Transaction Date",
  //     teaType: "Tea Type",
  //     status: "Status",
  //     pendingDaysForPayment: "Pending Days for Payment",
  //     overDueDays: "Over Due Days",
  //   };
  //   setPaymentHeaderMapping(paymentHeaderMapping);

  //   const payloadData = {
  //     season: season,
  //     saleNo: saleNo,
  //     auctionCenterId: auctionCenterId,
  //   };
  //   if (reportType == "7") {
  //     if (season !== "" && saleNo !== "") {
  //       try {
  //         const data = await getSaleProgramDetails(payloadData);
  //         setLoader(true);
  //         setProgramDetails(data.responseData);
  //       } catch (error) {
  //         console.error("Error fetching report data:", error);
  //         setLoader(false);
  //       }
  //     }
  //   }
  // }, [season, saleNo]);

  useEffect(() => {
    let isMounted = true;

    const fetchProgramDetails = async () => {
      const payloadData = {
        season: season,
        saleNo: saleNo,
        auctionCenterId: auctionCenterId,
      };

      console.log(payloadData, "payloadData");
      if (reportType === "7" && season !== "" && saleNo !== "") {
        try {
          const data = await getSaleProgramDetails(payloadData);
          if (isMounted) {
            setLoader(true);
            setProgramDetails(data.responseData);
            // setProgramDetails((prevDetails) => [
            //   ...prevDetails,
            //   data.responseData,
            // ]);
          }
        } catch (error) {
          console.error("Error fetching report data:", error);
          if (isMounted) setLoader(false);
        }
      }
    };

    fetchProgramDetails();

    return () => {
      isMounted = false;
    };
  }, [season, saleNo, reportType, auctionCenterId]);

  const handleSearch = async (e) => {
    e.preventDefault();
    const { saleNoWise, paymentDateRange } = viewOption;

    let tempData = {};

    if (paymentDateRange) {
      tempData = {
        paymentDateRange: paymentDateRange,
        saleNoWise: saleNoWise,
        entity: userID,
        report: report,
        paymentStartDate: new Date(paymentStartDate)
          .toISOString()
          .split("T")[0],
        paymentEndDate: new Date(paymentEndDate).toISOString().split("T")[0],
        reportFor: parseInt(reportFor),
        auctionVarient: parseInt(auctionVarient),
        auctionCenterId: parseInt(auctionCenterId),
        season: null,
        saleNo: null,
      };
    } else {
      tempData = {
        paymentDateRange: paymentDateRange,
        saleNoWise: saleNoWise,
        season: parseInt(season),
        saleNo: saleNo,
        entity: userID,
        report: report,
        reportFor: parseInt(reportFor),
        auctionVarient: parseInt(auctionVarient),
        auctionCenterId: parseInt(auctionCenterId),
        paymentStartDate: null,
        paymentEndDate: null,
      };
    }

    if (saleNoWise || paymentDateRange) {
      if (reportType == "1" || reportType == "2") {
        try {
          const data = await fetchReportDataTcsDetails(tempData);
          setLoader(true);
          console.log(data.responseData, "res");
          setData(data.responseData);
          if (!data.responseData) {
            CustomToast.error(data.message);
          }
        } catch (error) {
          console.error("Error fetching report data:", error);
          setLoader(false);
        }
      }

      if (reportType == "3" || reportType == "4") {
        try {
          const data = await fetchReportDataTdsDetails(tempData);
          setLoader(true);
          setData(data.responseData);
          if (!data.responseData) {
            CustomToast.error(data.message);
          }
        } catch (error) {
          console.error("Error fetching report data:", error);
          setLoader(false);
        }
      }
    }

    if (reportType == "5") {
      let invoiceData = {
        season: season,
        saleNo: parseInt(saleNo),
        auctioneerId: parseInt(auctioneerId),
      };
      try {
        if (!season) {
          CustomToast.error("Please select season Number");
        } else if (!saleNo) {
          CustomToast.error("Please select sale Number");
        } else if (!auctioneerId) {
          CustomToast.error("Please select auctioneer");
        } else {
          setWarehouseUserInvoice(null);
          const data = await getWarehouseUserInvoice(invoiceData);
          setLoader(true);
          // toast.success(data.message)
          setWarehouseUserInvoice(data.responseData);
          if (!data.responseData) {
            CustomToast.error(data.message);
          }
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
        setLoader(false);
      }
    }

    if (reportType == "6") {
      let categoryData = {
        auctionCenterId: auctionCenterId,
        season: season,
        month: month,
      };
      try {
        const data = await categoryWiseSoldQty(categoryData);
        setLoader(true);
        // toast.success(data.message)
        setCategoryListData(data.responseData);
        if (!data.responseData) {
          CustomToast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
        setLoader(false);
      }
    }

    if (reportType == "7") {
      let buyerPaymenttemData = {
        season: season || null,
        saleNo: saleNo || null,
        auctionDate: auction_date || null,
        buyerPromptDate: buyer_prompt_date || null,
        status: status || null,
        auctionCenterId: auctionCenterId || null,
      };
      try {
        const data = await buyerPaymentStatusReport(buyerPaymenttemData);

        // toast.success(data.message)
        console.log(data, "data_checek");
        setBuyerPaymentData(data?.responseData);
        if (data?.responseData?.buyerPaymentStatusReportVal.length > 0) {
          setLoader(true);
        } else {
          setLoader(false);
        }

        if (!data.responseData) {
          CustomToast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
        setLoader(false);
      }
    }
  };

  function download(filename, base64Zip) {
    var element = document.createElement("a");
    element.setAttribute("href", "data:text/plain;base64," + base64Zip);
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  useEffect(() => {
    if (warehouseUserInvoice != null) {
      download("Warehouse_User_Service_Invoice.zip", warehouseUserInvoice);
    }
  }, [warehouseUserInvoice]);

  const handleClear = () => {
    setFormData({
      season: "",
      saleNo: "",
      entity: userID,
      report: report,
      paymentStartDate: new Date(),
      paymentEndDate: new Date(),
      reportFor: reportType,
      status: status,
      auction_date: auction_date,
      buyer_prompt_date: auction_date,
    });
    setViewOption({
      saleNoWise: 0,
      paymentDateRange: 1,
    });

    setData(null);
    setCategoryListData(null);
    setWarehouseUserInvoice(null);
    setLoader(false);
    setBuyerPaymentData(null);
    setAuctioneerList(null);
  };

  const rowStyle = {
    textAlign: "center",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "30px",
  };

  return (
    <div>
      {reportType !== "5" && reportType !== "6" && reportType !== "7" && (
        <div className="row" style={rowStyle}>
          <div className="col-md-2">
            <div>
              <input
                type="radio"
                id="paymentDateRange"
                name="viewOption"
                value="paymentDateRange"
                checked={viewOption.paymentDateRange === 1}
                onChange={() => handleRadioChange("paymentDateRange")}
              />
              <label htmlFor="paymentDateRange" className="ml-2">
                Payment Date Range
              </label>
            </div>
          </div>
          <div className="col-md-2">
            <div>
              <input
                type="radio"
                id="saleNoWise"
                name="viewOption"
                value="saleNoWise"
                checked={viewOption.saleNoWise === 1}
                onChange={() => handleRadioChange("saleNoWise")}
              />
              <label htmlFor="saleNoWise" className="ml-2">
                Sale No Wise
              </label>
            </div>
          </div>
        </div>
      )}

      <div className="row" style={rowStyle}>
        <>
          <div className="col-md-2">
            <label>Season</label>
            {/* <label className="errorLabel"> * </label> */}
            <select
              className="form-control select-form"
              name="season"
              value={season}
              onChange={handleChange}
              disabled={
                !saleNoWise &&
                reportType !== "5" &&
                reportType !== "6" &&
                reportType !== "7"
              }
            >
              <option value="">Select season</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          {reportType !== "6" && (
            <div className="col-md-2">
              <div className="FomrGroup">
                <label>Sale No</label>
                <select
                  name="saleNo"
                  value={saleNo}
                  className="form-control select-form"
                  onChange={handleChange}
                  disabled={
                    !saleNoWise && reportType !== "5" && reportType !== "7"
                  }
                >
                  <option value="">Select Sale No</option>
                  {allSaleNoList.map((saleNoItem, index) => (
                    <option value={saleNoItem.saleNo} key={index}>
                      {saleNoItem.saleNo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {reportType == "7" && (
            <>
              <div className="col-md-2">
                <label>Status</label>
                <select
                  className="form-control select-form"
                  name="status"
                  value={status}
                  onChange={handleChange}
                >
                  <option value={0}>pending</option>
                  <option value={1}>complete</option>
                </select>
              </div>

              <div className="col-md-2">
                <label>Auction Date</label>
                <select
                  className="form-control select-form"
                  name="auction_date"
                  value={auction_date}
                  onChange={handleChange}
                >
                  <option value="">Select Auction Date</option>
                  {programDetails?.length > 0 &&
                    programDetails.map((item, index) => (
                      <option value={item.sellersPromptDate} key={index}>
                        {item.sellersPromptDate}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>Buyer’s Prompt Date</label>
                <select
                  className="form-control select-form"
                  name="buyer_prompt_date"
                  value={buyer_prompt_date}
                  onChange={handleChange}
                >
                  <option value="">Select buyer’s Prompt Date</option>
                  {programDetails?.length > 0 &&
                    programDetails.map((item, index) => (
                      <option value={item.buyersPromptDate} key={index}>
                        {item.buyersPromptDate}
                      </option>
                    ))}
                </select>
              </div>
            </>
          )}

          {reportType == "6" && (
            <div className="col-md-2">
              <div className="FomrGroup">
                <label>Month</label>
                <select
                  name="month"
                  value={month}
                  className="form-control select-form"
                  onChange={handleChange}
                >
                  <option value="">Select month</option>
                  {[
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ].map((monthName, index) => (
                    <option key={index} value={monthName}>
                      {monthName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {reportType == "5" && (
            <div className="col-md-2">
              <div className="FomrGroup">
                <label>Auctioneer</label>
                <select
                  name="auctioneerId"
                  value={auctioneerId}
                  className="form-control select-form"
                  onChange={handleChange}
                >
                  <option value="">Select auctioneer</option>
                  {auctioneerList?.map((item, index) => (
                    <option value={item.auctioneerId} key={item.userId}>
                      {item.auctioneerCode}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </>

        {reportType !== "5" && reportType !== "6" && reportType !== "7" && (
          <>
            <div className="col-md-2">
              <label>Entity</label>
              <select
                className="form-control select-form"
                name="entity"
                value={entity}
                onChange={handleChange}
              >
                <option value="3">Auctioneer</option>
                <option value="4">Seller</option>
              </select>
            </div>

            <div className="col-md-2">
              <label>Report</label>
              <select
                className="form-control select-form"
                name="report"
                value={report}
                onChange={handleChange}
              >
                <option value="1">Detail</option>
                <option value="2">Summary</option>
              </select>
            </div>
          </>
        )}

        {reportType !== "5" && reportType !== "6" && reportType !== "7" && (
          <>
            <div className="col-md-2">
              <label>Payment Start Date</label>
              <DatePicker
                selected={paymentStartDate}
                onChange={(date) =>
                  setFormData({ ...formData, paymentStartDate: date })
                }
                dateFormat="dd-MM-yyyy"
                className="form-control"
                disabled={saleNoWise}
              />
            </div>

            <div className="col-md-2">
              <label>Payment End Date</label>
              <DatePicker
                selected={paymentEndDate}
                onChange={(date) =>
                  setFormData({ ...formData, paymentEndDate: date })
                }
                dateFormat="dd-MM-yyyy"
                className="form-control"
                disabled={saleNoWise}
              />
            </div>
          </>
        )}
      </div>

      <div className="BtnGroup">
        <div>
          <button onClick={handleClear} className="SubmitBtn">
            Clear
          </button>
        </div>
        <div>
          <button onClick={handleSearch} className="SubmitBtn">
            Search
          </button>
        </div>
      </div>

      {reportType !== "5" && reportType !== "6" && reportType !== "7" && (
        <>
          <div
            style={{ overflowX: "auto", maxWidth: "100%", marginTop: "20px" }}
            id="table-content"
            ref={pdfContainerRef}
          >
            <table border="1" style={{ width: "100%", tableLayout: "fixed" }}>
              {data ? (
                <>
                  <thead>
                    <tr>
                      {data?.headers.map((header, index) => (
                        <th key={index} style={{ wordWrap: "break-word" }}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.cellValueList.length > 0 ? (
                      <>
                        {data?.cellValueList.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {data.headers.map((header, headerIndex) => {
                              const cellKey = header;
                              return (
                                <td
                                  key={headerIndex}
                                  style={{ wordWrap: "break-word" }}
                                >
                                  {row[cellKey] || "-"}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={31}>
                          {loader && (
                            <>
                              <div className="">
                                <ThreeDots
                                  visible={true}
                                  height="80"
                                  width="80"
                                  color="#4fa94d"
                                  radius="9"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                />
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </>
              ) : (
                <div className="NoData">No record found</div>
              )}
            </table>
          </div>
        </>
      )}

      {reportType == "6" && (
        <>
          <div
            style={{ overflowX: "auto", maxWidth: "100%", marginTop: "20px" }}
            id="table-content"
            ref={pdfContainerRef}
          >
            <table border="1" style={{ width: "100%", tableLayout: "fixed" }}>
              {categoryListData?.categogyList.length > 0 ? (
                <>
                  <thead>
                    <tr>
                      <th style={{ wordWrap: "break-word" }}>Category</th>
                      <th style={{ wordWrap: "break-word" }}>Packages</th>
                      <th style={{ wordWrap: "break-word" }}>Quantity (KGs)</th>
                      <th style={{ wordWrap: "break-word" }}>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoryListData?.categogyList.length > 0 ? (
                      <>
                        {categoryListData?.categogyList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td style={{ wordWrap: "break-word" }}>
                                {item.category}
                              </td>
                              <td style={{ wordWrap: "break-word" }}>
                                {item.packages}
                              </td>
                              <td style={{ wordWrap: "break-word" }}>
                                {item.qtyKGs}
                              </td>
                              <td style={{ wordWrap: "break-word" }}>
                                {item.price}
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <td style={{ wordWrap: "break-word" }}>
                            <b>Total</b>
                          </td>
                          <td style={{ wordWrap: "break-word" }}>
                            <b>{categoryListData?.totalPackages}</b>
                          </td>
                          <td style={{ wordWrap: "break-word" }}>
                            <b> {categoryListData?.totalQtyKGs}</b>
                          </td>
                          <td style={{ wordWrap: "break-word" }}>
                            <b>{categoryListData?.totalPrice}</b>
                          </td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td colSpan={31}>
                          {loader && (
                            <>
                              <div className="">
                                <ThreeDots
                                  visible={true}
                                  height="80"
                                  width="80"
                                  color="#4fa94d"
                                  radius="9"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                />
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </>
              ) : (
                <div className="NoData">No record found</div>
              )}
            </table>
          </div>
        </>
      )}

      {(categoryListData?.categogyList.length > 0 ||
        data?.headers.length > 0) && (
        <div className="BtnGroup">
          <button className="SubmitBtn" onClick={PrintPreview}>
            Print
          </button>

          <button onClick={handleExcelExport} className="SubmitBtn">
            Export to Excel
          </button>

          <button
            className="SubmitBtn"
            onClick={() =>
              generatePDF(pdfContainerRef, { filename: "exportPDF.pdf" })
            }
          >
            Export to PDF
          </button>
        </div>
      )}

      {reportType == "7" && (
        <>
          <div
            style={{ overflowX: "auto", maxWidth: "100%", marginTop: "20px" }}
            id="table-content"
            ref={pdfContainerRef}
          >
            {/* <table border="1" style={{ width: "100%", tableLayout: "fixed" }}>
              {buyerPaymentData ? (
                <>
                  <thead>
                    <tr>
                      {buyerPaymentData?.headers.map((header, index) => (
                        <th key={index} style={{ wordWrap: "break-word" }}>
                          {paymentHeaderMapping[header] || header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {buyerPaymentData?.buyerPaymentStatusReportVal.length >
                    0 ? (
                      <>
                        {buyerPaymentData?.map(
                          (row, rowIndex) => (
                            <tr key={rowIndex}>
                              {buyerPaymentData.headers.map(
                                (header, headerIndex) => {
                                  const cellKey = header;
                                  return (
                                    <td
                                      key={headerIndex}
                                      style={{ wordWrap: "break-word" }}
                                    >
                                      {row[cellKey] || "-"}
                                    </td>
                                  );
                                }
                              )}
                            </tr>
                          )
                        )}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={31}>
                          {loader && (
                            <>
                              <div className="">
                                <ThreeDots
                                  visible={true}
                                  height="80"
                                  width="80"
                                  color="#4fa94d"
                                  radius="9"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                />
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </>
              ) : (
                <div className="NoData">No record found</div>
              )}
            </table> */}
            <table border="1" style={{ width: "100%", tableLayout: "fixed" }}>
              {buyerPaymentData &&
              buyerPaymentData.buyerPaymentStatusReportVal ? (
                <>
                  <thead>
                    <tr>
                      {buyerPaymentData.headers.map((header, index) => (
                        <th key={index} style={{ wordWrap: "break-word" }}>
                          {/* {paymentHeaderMapping[header] || header} */}
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {buyerPaymentData.buyerPaymentStatusReportVal.length > 0 ? (
                      buyerPaymentData.buyerPaymentStatusReportVal.map(
                        (row, rowIndex) => (
                          <tr key={rowIndex}>
                            {buyerPaymentData.headers.map(
                              (header, headerIndex) => {
                                const cellKey = header;
                                return (
                                  <td
                                    key={headerIndex}
                                    style={{ wordWrap: "break-word" }}
                                  >
                                    {row[cellKey] || "-"}
                                  </td>
                                );
                              }
                            )}
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan={buyerPaymentData.headers.length}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </>
              ) : (
                <div className="NoData">No record found</div>
              )}
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default MyReportsTest;
